import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { listLanguage } from '../../../../../../configs/LanguageConfig';
import ScrollComponent from '../../../../../common/ScrollComponent';
import { getAlertMessage, getAlertTitle } from '../../../../../helpers/Alert';
import { getNewsUrl } from '../../../../../helpers/Common';
import Layout from '../../../../../helpers/Layout';
import { TABS } from '../../../../../tools/alerts/Const';
import { REDUCER_NAME } from '../reducer';
import CommonConst from '../../../../../common/Const';
const { listComponent } = CommonConst;

class NotificationList extends PureComponent {
  state = {
    isShow: false,
  };
  rootRef = React.createRef();

  getTime = notification => {
    const { locale } = this.props;
    return moment(notification.createDate)
      .locale(locale)
      .fromNow();
  };

  openAlertHistory = (e, notification) => {
    const { locale } = this.props;
    if (notification.newsId || notification.newsEnId) {
      const newsId =
        locale === listLanguage.en
          ? notification.newsEnId
          : notification.newsId;
      window.open(getNewsUrl(locale, newsId));

      return;
    }
    e.preventDefault();
    Layout.layout.createPopout(
      {
        componentName: listComponent.Alerts,
        component: listComponent.Alerts,
        type: 'react-component',
        title: I18n.t(`common.listComponent.${listComponent.Alerts}`),
        props: {
          initTab: TABS.ALERT_HISTORY,
        },
      },
      {
        width: window.screen.width / 2,
        height: window.screen.height,
        left: 50,
        top: 50,
      },
    );
  };

  renderNotifications = () => {
    const { notifications, locale } = this.props;
    if (!notifications.length) {
      return (
        <div className="d-flex w-100 align-content-stretch">
          {I18n.t('alerts.noNotification')}
        </div>
      );
    }

    return notifications.map((notification, index) => (
      <div
        onClick={e => this.openAlertHistory(e, notification)}
        key={index}
        className="d-flex w-100 align-content-stretch li-alert-content"
      >
        <div className="alert-img d-flex align-items-center justify-content-center">
          {notification.ticker}
        </div>
        <div className="alert-content d-flex flex-column justify-content-between">
          <div className=" d-flex justify-content-between">
            <span className="alert-title">
              {getAlertTitle(notification, locale)}
            </span>
            <span className="alert-time">{this.getTime(notification)}</span>
          </div>
          <span
            title={getAlertMessage(notification, locale)}
            className="alert-mess"
          >
            {notification.newsId && <i className="icon-star mr-2" />}
            {getAlertMessage(notification, locale)}
          </span>
        </div>
      </div>
    ));
  };

  render() {
    const { onScroll } = this.props;
    return (
      <li className="header-drop-notis dropdown-alert-content pb-10">
        <ScrollComponent
          appendHandleScroll={onScroll}
          appendStyle={{ maxHeight: 350 }}
        >
          <div className="pl-10 pr-10">{this.renderNotifications()}</div>
        </ScrollComponent>
      </li>
    );
  }
}

NotificationList.propTypes = {
  notifications: PropTypes.array,
  locale: PropTypes.string,
};

NotificationList.defaultProps = {
  notifications: [],
};
const mapStateToProps = (state, { type }) => ({
  notifications: state[REDUCER_NAME].notification[type],
  locale: state.i18n.locale,
});

export default connect(mapStateToProps)(NotificationList);
